import { useSelector } from "react-redux";

import { selectIsGuestLoggedIn } from "newui/features/Auth/authSelectors";

import { RBAC_STRINGS } from "../constants/rbacStrings";

/**
 * FE-4 guest action-block state. A guest is view-only: every mutating control
 * renders DISABLED with an upgrade CTA (never hidden). Guest identity is read
 * from the canonical `selectIsGuestLoggedIn` selector — this hook does NOT
 * duplicate guest logic, it only surfaces the block copy consistently.
 */
export interface GuestActionBlock {
	isGuest: boolean;
	/** Server key mirror; copy sourced from `rbac.guest_upgrade_required`. */
	message: string;
	ctaLabel: string;
	viewOnlyLabel: string;
}

export const useGuestActionBlock = (): GuestActionBlock => {
	const isGuest = useSelector(selectIsGuestLoggedIn);

	return {
		isGuest,
		message: RBAC_STRINGS.guest.upgradeRequired,
		ctaLabel: RBAC_STRINGS.guest.upgradeCta,
		viewOnlyLabel: RBAC_STRINGS.guest.viewOnly,
	};
};
